export const isLocalEnvironment = (): boolean => {
  // @ts-expect-error 2339
  return import.meta.env.VITE_ENV === 'L'
}
